<script setup lang="ts">
import {InlineLoader} from "@bookingkit/coppi";
</script>
<template>
  <div class="loading">
    <inline-loader size="xl"/>
  </div>
</template>
<style scoped>
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.c-spinner {
  stroke: var(--color-neutral-6);
}
</style>
